import Footer from './Footer';
export default {
    install: function (Vue) {
        Vue.component('YyFooter', Footer);
    }
}


// WEBPACK FOOTER //
// ./src/mix.js